import React from 'react'

type Props = {
  authed: boolean
  title: string
  saving: boolean
  onPublish: () => void
  onOpenPublish: () => void
  onCancel: () => void
  publishDisabled?: boolean
  publishDisabledReason?: string | null
  accessSummary?: string | null
  pixeBalance?: string | null
  publishCostPixe?: string
  lowBalance?: boolean
}

export default function PublishActions({
  authed,
  title,
  saving,
  onPublish,
  onOpenPublish,
  onCancel,
  publishDisabled,
  publishDisabledReason,
  accessSummary,
  pixeBalance,
  publishCostPixe = '1',
  lowBalance = false,
}: Props) {
  const disabled = Boolean(publishDisabled) || !authed || !title.trim() || saving
  return (
    <div className="space-y-2">
      <div className="flex flex-wrap items-center justify-between gap-2">
        {accessSummary ? (
          <div className="text-xs text-white/70">
            Access: <span className="font-semibold text-white/85">{accessSummary}</span>
          </div>
        ) : (
          <div />
        )}
        {publishDisabledReason ? <div className="text-xs text-red-300">{publishDisabledReason}</div> : null}
      </div>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-white/70">
        <span>
          Balance: <span className="font-semibold text-white/85">{pixeBalance || '0'} PIXE</span>
        </span>
        <span>
          Cost: <span className="font-semibold text-white/85">{publishCostPixe} PIXE</span>
        </span>
        {lowBalance ? <span className="text-amber-300">Insufficient balance for publish.</span> : null}
      </div>
      <div className="flex gap-3">
        <button
          onClick={onPublish}
          disabled={disabled}
          className="inline-flex items-center rounded-lg bg-brand px-5 py-2 font-semibold text-white hover:bg-brand-600 disabled:opacity-60"
        >
          {saving ? 'Publishing…' : 'Publish'}
        </button>
        <button type="button" onClick={onOpenPublish} className="inline-flex items-center rounded-lg border border-white/15 px-5 py-2 font-semibold hover:bg-white/5">
          Settings
        </button>
        <button type="button" onClick={onCancel} className="inline-flex items-center rounded-lg border border-white/15 px-5 py-2 font-semibold hover:bg-white/5">
          Cancel
        </button>
      </div>
    </div>
  )
}

